// ==========================================================
// S-MAN mock data (frontend-only teaser). Swap with backend.
// ==========================================================

const BOX = 'https://customer-assets-lqy194kg.emergentagent.net/job_sman-power-portal/artifacts/';

export const FLAVOUR_ORDER = ['strawberry', 'banana', 'mint', 'orange', 'apple', 'blueberry'];

export const FLAVOURS = {
  strawberry: {
    id: 'strawberry',
    name: 'STRAWBERRY',
    primary: '#FF2D2D',
    secondary: '#8F1018',
    rgb: '255, 45, 45',
    tagline: 'BOLD. JUICY. ICONIC.',
    personality: 'A classic for a reason. Sweet, intense and always a favourite.',
    fruit: 'https://images.unsplash.com/photo-1610725664338-2be2cb450798',
    box: BOX + '680xd29n_ChatGPT%20Image%2012%20set%202026%2C%2016_58_06.png',
    scene: BOX + 'rujijyme_ChatGPT%20Image%2012%20set%202026%2C%2016_04_10.png',
    woo: 1968, wooCombo5: 868, available: true,
    rating: 4.9,
    reviews: 312,
  },
  banana: {
    id: 'banana',
    name: 'BANANA',
    primary: '#FFC61A',
    secondary: '#A87800',
    rgb: '255, 198, 26',
    tagline: 'SMOOTH. RICH. UNEXPECTED.',
    personality: 'Creamy, smooth and delicious. A unique twist on performance.',
    fruit: 'https://images.unsplash.com/photo-1558665659-d997797dd688',
    box: 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/57e2c58fe627b3d3dd9898456e920f903f8db10772abe01b435e0c6f7e96ab6c.jpeg',
    woo: 908, wooCombo5: 1986, available: true,
    rating: 4.7,
    reviews: 241,
  },
  mint: {
    id: 'mint',
    name: 'MINT',
    primary: '#00C896',
    secondary: '#006B55',
    rgb: '0, 200, 150',
    tagline: 'COOL. CLEAN. FRESH.',
    personality: 'Refreshing taste. A clean, powerful experience.',
    fruit: 'https://images.unsplash.com/photo-1618130070080-91f4d55a2383',
    box: 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/2d152759f63324cdff1f1cca007cba3e1a62f5b7de9f1adf8ab8d808ed925b97.jpeg',
    woo: 892, wooCombo5: 2005, available: true,
    rating: 4.8,
    reviews: 268,
  },
  orange: {
    id: 'orange',
    name: 'ORANGE',
    primary: '#FF8A00',
    secondary: '#A94300',
    rgb: '255, 138, 0',
    tagline: 'BRIGHT. CITRUS. ENERGETIC.',
    personality: 'Zesty, vibrant and full of character. Pure energy in every chew.',
    fruit: 'https://images.unsplash.com/photo-1584209786780-86d74997914e',
    box: 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/0ee967976898b5586b0e1433a89a549745384c84d5a888b70b3fe1e54b547336.jpeg',
    woo: 1602, wooCombo5: 1965, available: true,
    rating: 4.9,
    reviews: 237,
  },
  apple: {
    id: 'apple',
    name: 'APPLE',
    primary: '#7ED321',
    secondary: '#387B12',
    rgb: '126, 211, 33',
    tagline: 'CRISP. FRESH. SHARP.',
    personality: 'Fresh, crisp and bold. A modern classic with a kick.',
    fruit: 'https://images.unsplash.com/photo-1580829528279-6c364c5c7ea8',
    box: 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/5394549bd733a50b177fd670b22331a19d921d83ad3100017443814906bf6697.jpeg',
    woo: 1620, wooCombo5: 1946, available: true,
    rating: 4.8,
    reviews: 190,
  },
  blueberry: {
    id: 'blueberry',
    name: 'BLUEBERRY',
    primary: '#2F8FFF',
    secondary: '#1157A6',
    rgb: '47, 143, 255',
    tagline: 'DEEP. RICH. INTENSE.',
    personality: 'Deep, juicy and full of character. A bold berry hit of energy.',
    fruit: 'https://images.unsplash.com/photo-1498557850523-fd3d118b962e',
    box: 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/caee392b9089ce0874f8a6fbdc3c870093df5e823fba419944d2fca74101a21c.jpeg',
    woo: null, wooCombo5: null, available: false, comingSoon: 'FEBRUARY 2027',
    rating: 4.8,
    reviews: 205,
  },
};

// Bundles / pricing (mocked - to be pulled from WooCommerce later)
export const BUNDLES = [
  {
    id: 'box-1',
    boxes: 1,
    label: 'TRY IT',
    sub: '1 BOX',
    price: 17.0,
    compareAt: null,
    perUnit: 17.0,
    saving: null,
    popular: false,
    type: 'single',
  },
  {
    id: 'box-2',
    boxes: 2,
    label: 'BEST CHOICE',
    sub: '2 BOXES',
    price: 30.0,
    compareAt: 34.0,
    perUnit: 15.0,
    saving: '12%',
    popular: false,
    type: 'single',
  },
  {
    id: 'box-3',
    boxes: 3,
    label: 'MOST POPULAR',
    sub: '3 BOXES',
    price: 39.0,
    compareAt: 51.0,
    perUnit: 13.0,
    saving: '24%',
    popular: true,
    type: 'single',
  },
  {
    id: 'mix-5',
    boxes: 6,
    label: 'THE FULL EXPERIENCE',
    sub: '6-FLAVOUR MIX',
    price: 90.0,
    compareAt: 102.0,
    perUnit: 15.0,
    saving: '12%',
    popular: false,
    type: 'mix',
  },
];

export const MIX_PRICE_PER_UNIT = 15.0;

export const INGREDIENTS = [
  { id: 'nitrosigine', name: 'Nitrosigine\u00ae', amount: '1,500 mg', tag: 'CIRCULATION & PERFORMANCE', claim: 'Patented bonded arginine silicate that supports healthy blood flow and nutrient delivery.', image: 'https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6' },
  { id: 'beetroot', name: 'Beetroot Extract', amount: '1,500 mg', tag: 'NATURAL NITRATES', claim: 'A natural source of dietary nitrates, traditionally used to support vitality.', image: 'https://images.unsplash.com/photo-1612863914721-442b8ed6d811' },
  { id: 'pycnogenol', name: 'Pycnogenol\u00ae', amount: '120 mg', tag: 'ANTIOXIDANT SUPPORT', claim: 'A branded French maritime pine bark extract with antioxidant properties.', image: 'https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6' },
  { id: 'ginseng', name: 'Panax Ginseng', amount: '300 mg', tag: 'ENERGY & VITALITY', claim: 'A classic adaptogenic root traditionally used to support energy and focus.', image: 'https://images.unsplash.com/photo-1718686243213-5a3d73fd678f' },
  { id: 'maca', name: 'Maca', amount: '400 mg', tag: 'STAMINA & DRIVE', claim: 'A Peruvian root traditionally valued for stamina and wellbeing.', image: 'https://images.unsplash.com/photo-1708369469602-f6d7fced1270' },
  { id: 'affron', name: 'affron\u00ae', amount: '30 mg', tag: 'MOOD & WELLBEING', claim: 'A branded saffron extract studied for mood and wellbeing support.', image: 'https://images.unsplash.com/photo-1613549026674-2b6c58226395' },
  { id: 'taurine', name: 'Taurine', amount: '600 mg', tag: 'PHYSICAL PERFORMANCE', claim: 'An amino acid commonly included in energy and performance formulas.', image: 'https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6' },
  { id: 'zinc', name: 'Zinc', amount: '10 mg', tag: 'IMMUNE & HORMONAL SUPPORT', claim: 'An essential mineral that contributes to normal testosterone levels in the blood.', image: 'https://images.unsplash.com/photo-1609216970141-d981d693484a' },
  { id: 'piperine', name: 'Piperine', amount: '2 mg', tag: 'ABSORPTION ENHANCER', claim: 'Black pepper extract included to support absorption of the other ingredients.', image: 'https://images.unsplash.com/photo-1647170759280-1cf055c967eb' },
];

// NOTE: real reviews only — placeholder set to be replaced with genuine reviews.
export const REVIEWS = [
  { id: 1, name: 'Matteo L.', country: 'IT', rating: 5, flavour: 'mint', verified: true, text: 'Amazing taste and great quality. This is now part of my daily routine.' },
  { id: 2, name: 'Daniel K.', country: 'DE', rating: 5, flavour: 'mix', verified: true, text: 'Finally a supplement that actually tastes good. I tried the mix box and all flavours are excellent.' },
  { id: 3, name: 'Alex P.', country: 'GB', rating: 5, flavour: 'orange', verified: true, text: 'More energy. More confidence. Great taste.' },
  { id: 4, name: 'Chris T.', country: 'GR', rating: 5, flavour: 'mint', verified: true, text: 'Best tasting supplement I have ever used. Mint is my favourite!' },
  { id: 5, name: 'James R.', country: 'GB', rating: 5, flavour: 'strawberry', verified: true, text: 'Strawberry is next level! Great taste and I feel more focused during the day.' },
  { id: 6, name: 'Nikos S.', country: 'GR', rating: 5, flavour: 'mix', verified: true, text: 'Clean ingredients, incredible flavours. The mix box is perfect if you want to try them all.' },
  { id: 7, name: 'Lucas M.', country: 'FR', rating: 5, flavour: 'banana', verified: true, text: 'Great product. Tastes amazing and gives me that extra push when I need it.' },
  { id: 8, name: 'Stefano B.', country: 'IT', rating: 5, flavour: 'apple', verified: true, text: 'Apple flavour is surprisingly good! Will definitely order again.' },
  { id: 9, name: 'David M.', country: 'GR', rating: 5, flavour: 'orange', verified: true, text: 'Great taste. More energy. A better me.' },
  { id: 10, name: 'Andreas P.', country: 'GR', rating: 5, flavour: 'mint', verified: true, text: 'Exceeded my expectations. Great taste, high quality ingredients and I feel more focused during the day.' },
  { id: 11, name: 'Sarah K.', country: 'GB', rating: 5, flavour: 'mix', verified: true, text: 'The mix box is perfect. All flavours are great and delivery was fast.' },
  { id: 12, name: 'Marco T.', country: 'IT', rating: 5, flavour: 'strawberry', verified: true, text: 'Part of my daily routine. Gives me that extra push and the taste makes it easy to stay consistent.' },
];

export const REVIEW_STATS = { rating: 4.8, count: 1248, taste: 96, quality: 92, experience: 89, buyAgain: 94 };

export const QUIZ = [
  { q: 'What kind of taste do you usually enjoy?', a: [
    { label: 'Sweet & bold', flavour: 'strawberry' },
    { label: 'Smooth & creamy', flavour: 'banana' },
    { label: 'Fresh & cool', flavour: 'mint' },
    { label: 'Citrus & zesty', flavour: 'orange' },
    { label: 'Crisp & sharp', flavour: 'apple' },
  ]},
  { q: 'Pick your vibe.', a: [
    { label: 'Classic & iconic', flavour: 'strawberry' },
    { label: 'Unexpected & rich', flavour: 'banana' },
    { label: 'Clean & minimal', flavour: 'mint' },
    { label: 'Bright & energetic', flavour: 'orange' },
    { label: 'Modern & fresh', flavour: 'apple' },
  ]},
  { q: 'Choose a colour that speaks to you.', a: [
    { label: 'Red', flavour: 'strawberry' },
    { label: 'Gold', flavour: 'banana' },
    { label: 'Emerald', flavour: 'mint' },
    { label: 'Amber', flavour: 'orange' },
    { label: 'Green', flavour: 'apple' },
  ]},
];

export const FAQ = [
  { q: 'What is S-MAN?', a: 'S-MAN is a premium chewable food supplement for men, crafted with a carefully selected formula and available in six flavours.' },
  { q: 'How do I use S-MAN?', a: 'Follow the recommended daily serving indicated on the product label. Usage instructions are editable to match your final approved label.' },
  { q: 'How many servings are included?', a: 'Each box contains one month supply. Exact serving count is shown on the product label.' },
  { q: 'Are all flavours the same formula?', a: 'Yes. All six flavours share the exact same formula — only the taste is different.' },
  { q: 'Which flavours are available?', a: 'Strawberry, Banana, Mint, Orange, Apple and Blueberry.' },
  { q: 'Can I mix flavours?', a: 'Absolutely. Choose THE S-MAN SIX mix box or build your own mix of any six units.' },
  { q: 'How does discreet delivery work?', a: 'All orders ship in neutral, discreet packaging with no visible product information on the outside.' },
  { q: 'Where do you deliver?', a: 'We deliver across Europe. Delivery times and coverage may vary by country.' },
  { q: 'How should S-MAN be stored?', a: 'Store in a cool, dry place away from direct sunlight. Full storage guidance is on the label.' },
  { q: 'What payment methods are accepted?', a: 'Secure card payments and cash on delivery where available.' },
];

const CM = 'https://static.prod-images.emergentagent.com/jobs/18cf1ef2-791b-4c8d-a108-607f1b475608/images/';
export const COUNTRY_MANAGERS = [
  { id: 1, name: 'Marco Rossi', country: 'Italy', flag: '\ud83c\uddee\ud83c\uddf9', city: 'Milan', email: 'italy@the-sman.com', role: 'Country Manager — Italy', photo: CM + 'bdbdb1e077029c3accb573b50c05c5a7d4b706ba357e18b964998cc3c61e7ee4.jpeg' },
  { id: 2, name: 'Nikos Papadopoulos', country: 'Greece', flag: '\ud83c\uddec\ud83c\uddf7', city: 'Athens', email: 'greece@the-sman.com', role: 'Country Manager — Greece', photo: CM + '669fdc1b751ae581a405fb2636617cde77f54ed562084871c9cc9ffabf6cd480.jpeg' },
  { id: 3, name: 'James Carter', country: 'United Kingdom', flag: '\ud83c\uddec\ud83c\udde7', city: 'London', email: 'uk@the-sman.com', role: 'Country Manager — UK', photo: CM + 'bde7173a87a0fc56a66d32ab44339ceea18101dd136ac1a0bb7bda55f190efcd.jpeg' },
  { id: 4, name: 'Lucas Martin', country: 'France', flag: '\ud83c\uddeb\ud83c\uddf7', city: 'Paris', email: 'france@the-sman.com', role: 'Country Manager — France', photo: CM + '7d2d55df65e618c9e077bd92913314009978fb835c0c7f4869550841f8c21953.jpeg' },
  { id: 5, name: 'Lukas M\u00fcller', country: 'Germany', flag: '\ud83c\udde9\ud83c\uddea', city: 'Berlin', email: 'germany@the-sman.com', role: 'Country Manager — Germany', photo: CM + 'd9ed2c449c08c06e606a9ab276f39416f98bd6e33e53bc27bfe349fb650b3bae.jpeg' },
  { id: 6, name: 'Diego Fern\u00e1ndez', country: 'Spain', flag: '\ud83c\uddea\ud83c\uddf8', city: 'Madrid', email: 'spain@the-sman.com', role: 'Country Manager — Spain', photo: CM + '0ce23e2f7c3aafef8f6fbd866450dd45b31eebfe024610c9eb1a52f855b547bd.jpeg' },
  { id: 7, name: 'Piotr Kowalski', country: 'Poland', flag: '\ud83c\uddf5\ud83c\uddf1', city: 'Warsaw', email: 'poland@the-sman.com', role: 'Country Manager — Poland', photo: CM + '27bb42d0bb10c199262a48b6b18130df108e90ffcc716952d5906eb0103a3fcc.jpeg' },
  { id: 8, name: 'Daan de Vries', country: 'Netherlands', flag: '\ud83c\uddf3\ud83c\uddf1', city: 'Amsterdam', email: 'netherlands@the-sman.com', role: 'Country Manager — Netherlands', photo: CM + '6f5ef8b5f92da78f20a446e99ce0d7c4237ddf9972e4112d02ea21c75def2ef1.jpeg' },
];

// Cinematic brand films / reels. videoId = YouTube ID.
// NOTE: placeholder Creative-Commons films \u2014 replace videoId with your real S-MAN brand films.
export const VIDEOS = {
  feature: {
    id: 'film-main',
    tag: 'THE S-MAN FILM',
    title: 'FEEL THE ENERGY.',
    subtitle: 'A cinematic look at confidence, attraction and performance.',
    poster: 'https://images.unsplash.com/photo-1570216601541-fa11cfaf03e5',
    videoId: 'aqz-KE-bpKQ',
    duration: '1:12',
  },
  reels: [
    { id: 'r1', tag: 'BRAND FILM', title: 'OWN THE NIGHT', poster: 'https://images.unsplash.com/photo-1760143522247-e7b2454536da', videoId: 'eRsGyueVLvQ', duration: '0:45' },
    { id: 'r2', tag: 'LIFESTYLE', title: 'CONFIDENCE THAT SHOWS', poster: 'https://images.unsplash.com/photo-1587397845856-e6cf49176c70', videoId: 'R6MlUcmOul8', duration: '0:38' },
    { id: 'r3', tag: 'EVERYDAY', title: 'ENERGY, EVERY DAY', poster: 'https://images.unsplash.com/photo-1500389723459-ca24a5564899', videoId: 'TLkA0RELQ1g', duration: '0:52' },
    { id: 'r4', tag: 'SIX FLAVOURS', title: 'ONE FORMULA. SIX TASTES', poster: 'https://images.unsplash.com/photo-1554311884-415bfda22b47', videoId: 'aqz-KE-bpKQ', duration: '0:41' },
  ],
};

export const LIFESTYLE = {
  portraitBW: 'https://images.unsplash.com/photo-1587397845856-e6cf49176c70',
  confidentDark: 'https://images.unsplash.com/photo-1570216601541-fa11cfaf03e5',
  sunset: 'https://images.unsplash.com/photo-1500389723459-ca24a5564899',
  sunset2: 'https://images.unsplash.com/photo-1554311884-415bfda22b47',
  couple: 'https://images.unsplash.com/photo-1760143522247-e7b2454536da',
  cinemaMain: 'https://customer-assets-lqy194kg.emergentagent.net/job_sman-power-portal/artifacts/yrp07t8l_fc548ebe-d01d-4f46-9fd3-a3b1a9b07eea.JPG',
  cinemaRed: 'https://customer-assets-lqy194kg.emergentagent.net/job_sman-power-portal/artifacts/jn1ey378_f719038d-f59d-4373-a3e8-d6a405fc1125.JPG',
  cinemaFire: 'https://customer-assets-lqy194kg.emergentagent.net/job_sman-power-portal/artifacts/l1r6gdmr_68093407-00f7-4f70-9b42-aa0b40443c4f.JPG',
};
